<template>
  <div id="app">
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
    </keep-alive>
    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 获取 URL 查询字符串中的参数值
    var url = window.location.href;
    if (url.indexOf('JCRing_privacy_policy') == -1) {
      if (url.indexOf('JCRing') != -1) {
        document.querySelector('body').style.backgroundColor = '#000';
      } else {
        document.querySelector('body').style.backgroundColor = '#f6f6f6';
      }
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    }
  }
}
</script>

<style>
#app {
  /* font-family: 'MiSansRegular'; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 禁止长按 */
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -ms-content-zooming: none;
  /* IE/Edge */
  -moz-user-select: none;
  /* Firefox */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -webkit-tap-highlight-color: transparent;
  /* Android Chrome (>=30) */
}

html,
body {
  width: 100%;
  height: 100%;
  margin: auto;
  /* position: fixed;
    top: 0;
    left: 0; */
  -webkit-touch-callout: none;
  /*系统默认菜单被禁用*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -khtml-user-select: none;
  /*早期浏览器*/
  -moz-user-select: none;
  /*火狐*/
  -ms-user-select: none;
  /*IE10*/
  user-select: none;
}

/* 自定义高度 */
.cu-tabbar-height {
  height: 1.386666rem;
}

.padding-top {
  padding-top: 2.133333rem !important;
}

/* @font-face {
  font-family: 'MiSansRegular';
  src: url(https://szoss.jointcorp.cloud/res/hy/admin/fonts/MiSans-Regular.ttf) format('woff2');

} */
</style>



// WEBPACK FOOTER //
// src/App.vue